import React, {Component} from 'react'
import {connect} from 'react-redux'
import {api} from "../../../../api";
import {app} from "../../../../config/constants";
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ActionDeleteForever from 'material-ui/svg-icons/action/delete-forever';


class AppSettingsPromotionsComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			promotionSettings: []
		};

		this.saveSettings = this.saveSettings.bind(this);
	}

	componentDidMount() {
		let settings = [];

		let i = 0;

		new Promise(resolve => {
			api.promotions.types.map(type => {
				settings.push({
					type      : type.value,
					views     : 0,
					difference: 0,
				});

				if (++i === api.promotions.types.length) {
					resolve(settings);
				}
			});
		}).then(settings => {
			return this.setState({
				promotionSettings: settings
			})
		}).then(() => {
			app.database().ref('/cams/settings/promotions').once('value', promotionsSettingsSnap => {
				promotionsSettingsSnap.forEach(snap => {
					const {views, type, difference} = snap.val();

					this.setState({
						promotionSettings: [
							...this.state.promotionSettings.map(promotionSetting => {
								if (promotionSetting.type !== type) {
									return promotionSetting;
								}

								return {
									...promotionSetting,
									views     : views,
									difference: difference
								}
							})
						]
					})
				})
			});
		})
	}

	setPromotionTypeSetting(value, type, attr) {
		this.setState({
			promotionSettings: [
				...this.state.promotionSettings.map(setting => {
					if (setting.type !== type) {
						return setting;
					}

					return {
						...setting,
						[attr]: value
					}
				})
			]
		})
	}

	saveSettings() {
		let i = 0;

		this.state.promotionSettings.map(setting => {
			const promotionSettingRow = app.database().ref('/cams/settings/promotions').orderByChild('type').equalTo(setting.type);

			promotionSettingRow.once('value', snapShot => {
				if (null === snapShot.val()) {
					// Create record
					return app.database().ref('/cams/settings/promotions').push(setting);
				} else {
					app.database().ref('/cams/settings/promotions').child(Object.keys(snapShot.val())[0]).update(setting);
					// console.log( promotionSettingRow.update( setting ) );
					// Update record
					// snapShot.update( setting );
				}

			});

			if (++i === this.state.promotionSettings.length) {
				api.snackbar.showMessage( 'De instellingen zijn opgeslagen.');
			}
		});


	}

	render() {
		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h5>Automatische A/B tests</h5>
						<p>
							Vul hieronder de gewenste waarden in. Indien je bij beide velden "0" invult, dan wordt er niets mee gedaan. Vul het minimale verschil in met 2 decimalen, bijv. 0.25 of 1.45, zonder procent karakter.
						</p>
					</div>
					<div className="medium-12 cell small-order-2 medium-order-1">
						<div className="grid-x grid-padding-x">
							<div className="cell">
								<ul className={'ab_tests_list'}>
									{
										api.promotions.types.map((type, key) => {
											let settings = this.state.promotionSettings.find(promotionSetting => {
												return promotionSetting.type === type.value
											});

											if (undefined === settings) {
												settings = {
													views     : 0,
													difference: 0,
												}
											}

											return (
												<li key={key}>
													<strong>{type.title}</strong>
													<div className="grid-x grid-margin-x">
														<div className="cell medium-4">
															<label>
																Weergaven
																<TextField
																	onChange={(event) => this.setPromotionTypeSetting(event.target.value, type.value, 'views')}
																	value={settings.views}
																	data-settings-property="types"
																	name="name"
																	fieldkey={key}
																	fullWidth={true}
																/>
															</label>
														</div>
														<div className="cell medium-4">
															<label>
																Minimaal verschil
																<TextField
																	onChange={(event) => this.setPromotionTypeSetting(event.target.value, type.value, 'difference')}
																	value={settings.difference}
																	data-settings-property="types"
																	name="name"
																	fieldkey={key}
																	fullWidth={true}
																/>
															</label>
														</div>
													</div>
												</li>
											)
										})
									}
								</ul>


							</div>
						</div>
					</div>
				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-y">
					<div className="small-12 cell text-right">
						<RaisedButton
							label="Instellingen Opslaan"
							primary={true}
							onClick={this.saveSettings}
							fullWidth={true}
						/>
					</div>
				</div>

			</div>

		);
	}
}

const mapStateToProps = (state) => {
	return {}
};

export default connect(mapStateToProps)(AppSettingsPromotionsComponent)


// WEBPACK FOOTER //
// ./src/application/components/settings/promotions/index.js